import { type Component } from 'solid-js';

import { money } from '../lib/format.js';
import type { DashboardReport } from '../lib/types.js';

/**
 * The three numbers a merchant opens this app to see (SPEC FR-3).
 *
 * Laid out on `s-grid` rather than an inline `s-stack` so the figures keep even columns instead of
 * bunching at the left of a wide admin, and so they wrap to one-per-row on a narrow viewport.
 *
 * Overdue carries `tone="critical"`. That is the only number here that means someone has to act,
 * and it has to be findable at a glance. Note the tone goes on `s-text`, NOT on `s-heading` —
 * `s-heading` exposes only `accessibilityrole`, `lineclamp` and `accessibilityvisibility`, so a
 * tone set there is silently dropped.
 */
export const Totals: Component<{ report: DashboardReport }> = (props) => {
  return (
    <s-section>
      <s-grid gridTemplateColumns="1fr 1fr 1fr" gap="large">
        <s-box>
          <s-stack direction="block" gap="small-500">
            <s-text tone="subdued">Outstanding</s-text>
            <s-heading>{money(props.report.totals.outstandingCents, props.report.currency)}</s-heading>
          </s-stack>
        </s-box>
        <s-box>
          <s-stack direction="block" gap="small-500">
            <s-text tone="subdued">Overdue</s-text>
            <s-text tone="critical">
              <s-heading>{money(props.report.totals.overdueCents, props.report.currency)}</s-heading>
            </s-text>
          </s-stack>
        </s-box>
        <s-box>
          <s-stack direction="block" gap="small-500">
            <s-text tone="subdued">Current</s-text>
            <s-heading>{money(props.report.totals.currentCents, props.report.currency)}</s-heading>
          </s-stack>
        </s-box>
      </s-grid>
    </s-section>
  );
};
